var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// shared.js
var shared_exports = {};
__export(shared_exports, {
  Fragment: () => Fragment,
  appendChild: () => appendChild,
  getOuterHtmlAsText: () => getOuterHtmlAsText,
  handleDangerouslySetInnerHTML: () => handleDangerouslySetInnerHTML,
  handlePostCreate: () => handlePostCreate,
  handleRef: () => handleRef,
  isClass: () => isClass,
  namespaceTags: () => namespaceTags,
  svgNamespace: () => svgNamespace
});
function Fragment({ children, ...props }) {
  return new MyFrag(children);
}
function getOuterHtmlAsText(ele) {
  const template = document.createElement("div");
  template.appendChild(ele);
  return template.innerHTML;
}
function isClass(funcOrClass) {
  const propertyNames = Object.getOwnPropertyNames(funcOrClass);
  return propertyNames.includes("prototype") && !propertyNames.includes("arguments");
}
var svgNamespace, namespaceTags, handleDangerouslySetInnerHTML, handleRef, appendChild, handlePostCreate, MyFrag;
var init_shared = __esm({
  "shared.js"() {
    svgNamespace = "http://www.w3.org/2000/svg";
    namespaceTags = {
      "use": svgNamespace,
      "path": svgNamespace,
      "svg": svgNamespace,
      "g": svgNamespace,
      "rect": svgNamespace,
      "ellipse": svgNamespace,
      "circle": svgNamespace,
      "linearGradient": svgNamespace,
      "stop": svgNamespace,
      "clipPath": svgNamespace,
      "animate": svgNamespace
    };
    handleDangerouslySetInnerHTML = (element, props) => {
      let html = props.dangerouslySetInnerHTML.__html;
      if (props.dangerouslySetInnerHTML.symbols === true) {
        html = getOuterHtmlAsText(html);
        element.setAttribute("style", "display: none;");
      }
      element.innerHTML = html;
    };
    handleRef = (element, props) => {
      if (typeof props.ref == "function") {
        props.ref(element);
      }
    };
    appendChild = (parent, child) => {
      if (child) {
        if (child instanceof MyFrag) {
          appendChild(parent, child.content);
        } else if (typeof child.__nativeRenderRoutine == "function") {
          appendChild(parent, child.__nativeRenderRoutine());
        } else {
          if (Array.isArray(child)) {
            child.forEach((nestedChild) => appendChild(parent, nestedChild));
          } else {
            parent.appendChild(child.nodeType ? child : document.createTextNode(child));
          }
        }
      }
    };
    handlePostCreate = (element, props) => {
      if (typeof props.postCreate == "function") {
        props.postCreate(element);
      }
    };
    MyFrag = class {
      content = [];
      constructor(content) {
        if (Array.isArray(content)) {
          this.content = content;
        } else {
          this.content = [content];
        }
      }
    };
  }
});

export {
  __toCommonJS,
  shared_exports,
  init_shared
};
